<!--
 * @Description: 立即沟通
 * @Author:  单珊珊
 * @Date: 2023-12-26 14:18:11
 * @LastEditTime: 2023-12-26 14:55:49
 * @LastEditors:  
-->
<template>
  <Modal v-model="modelIndex" width="530" class="contactModel" @on-cancel="close" :footer-hide="true">
    <div class="contact-wrapper">
      <div class="model-bg">
        <p class="p1">全球产业链接平台</p>
      </div>
      <div class="desc-content" v-if="$route.name == 'IndustrialSolutions'">
        <div class="header">
          <div>
            <p>请扫描下方二维码联系客服</p>
          </div>
        </div>
        <div class="ewm">
          <img :src="static_img_url + 'pic/shangwuhezuo.png'" />
        </div>
      </div>
      <div class="desc-content" v-else>
        <div class="header">
          <div>
            <p>PC版IM功能正在开发中</p>
            <p>请扫码下载APP联系企业</p>
          </div>
        </div>
        <div class="ewm">
          <img :src="static_img_url + 'pic/download-code.png'" />
          <p>扫码下载APP，搜索企业名称，即可与企业联系</p>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      vcbeat_path: (state) => state.vcbeat_path,
      index2_path: (state) => state.index2_path,
      img_req_url: (state) => state.img_req_url,
    }),
  },
  data() {
    return {
      modelIndex: false,
    }
  },
  methods: {
    close() {
      this.modelIndex = false
    },
  },
}
</script>

<style lang="stylus" scoped>
.contactModel
  >>> .ivu-form-item-error-tip
    padding-top 3px
    color #FC3B3B
  >>> .ivu-modal-close
    top 10px
    &:hover
      i
        color #FA7A50
  >>> .ivu-modal-wrap
    display flex
    align-items center
    justify-content center
  >>> .ivu-modal
    position relative
    top auto
    .ivu-modal-content
      border-radius 10px
      background-clip initial
      .ivu-modal-body
        padding 0
      .contact-wrapper
        width 100%
        height 408px
        display flex
        .model-bg
          flex 0 0 170px
          max-width 170px
          min-width 170px
          background-image url('~pic/pc30/model-bg.png')
          background-size 100% 100%
          background-repeat no-repeat
          position relative
          .p1
            font-size 15px
            color #fff
            line-height 20px
            text-align center
            position absolute
            top 70px
            width 100%
            left 0
          .p2
            font-size 12px
            color #ffd0b7
            line-height 14px
            position absolute
            bottom 8px
            width 100%
            text-align center
            left 0
            transform scale(0.97)
        .desc-content
          flex 0 0 360px
          padding 20px 16px 20px 20px
          display flex
          flex-direction column
          .header
            display flex
            justify-content space-between
            align-items flex-end
            div
              padding-left 8px
              border-left 4px solid #FF8824
              p
                font-size 18px
                color #3D3D3D
                line-height 24px
          .ewm
            width 100%
            flex auto
            display flex
            flex-direction column
            align-items center
            justify-content center
            p
              font-size 14px
              color #333333
              line-height 20px
              margin-top 16px
            img
              width 120px
              height 120px
    .ivu-modal-close
      width 20px
      height 20px
      border-radius 50%
      display flex
      align-items center
      justify-content center
      background rgba(0, 0, 0, 0.3)
      right 16px
      top 20px
      i
        font-size 24px
        color #fff
</style>
